import { isRevolvingCreditProduct } from './productTypeHelpers';
const isDCHEligible = (billing, productType, featureFlags) => {
    const isPastDue = billing === null || billing === void 0 ? void 0 : billing.pastDue;
    const isEnrolledInCAP = billing === null || billing === void 0 ? void 0 : billing.customerAssistancePlan;
    const isSettlementEnrolled = billing === null || billing === void 0 ? void 0 : billing.settlementEnrolled;
    const isRevolvingCredit = isRevolvingCreditProduct(productType);
    return (featureFlags.isDigitalCollectionsEnabled &&
        isRevolvingCredit &&
        (isPastDue || isEnrolledInCAP || isSettlementEnrolled));
};
export default isDCHEligible;
